export default function LocationStorage() {
	const domains = ['eu','ca', 'intl', 'us'];
	const purchasePathPages = ['/cart','/checkout', '/products', '/pages/premium-subscription', '/pages/muse-connect', '/pages/compare', '/pages/shop', '/pages/shop-in-bulk', '/pages/shop-accessories'];
	const currentPage = window.location;

	const init = () => {
		if (window.location.origin === 'https://sandbox.choosemuse.com') return;
		checkCookieData();
		setCookieDataFromMenu();
	};

	const checkCookieData = () => {
		const cookie = getCookie('_muse_store');
		const prevCookie = getCookie('_muse_store_prev');
		const validCookie = domains.find(val => val === cookie);
		let subdomain = getSubDomain();
		const validSubdomain = domains.find(val => val === subdomain);
		const forced = getCookieForced();
		const validForced = domains.find(val => val === forced);
		const params = new URLSearchParams(window.location.search);
		const discountCode = params.get('discount')
		/* console.log('checkCookieData', cookie, validCookie, subdomain, validSubdomain); */

		if (validForced) {
			setCookieData(forced);
		} else if (validSubdomain /* && cookie !== subdomain */ && prevCookie != subdomain) {
			setCookieData(subdomain);
		} else if (validCookie) {
			setCookieData(cookie);
		} else {
			setCookieData('us');
			subdomain = 'us';
		}

		if (discountCode && location.hostname === 'choosemuse.com') {
			domains.filter(v => v !== 'us').forEach(sub => {
				const iframe = document.createElement('iframe');
				iframe.setAttribute('src', encodeURI(`https://${sub}.choosemuse.com/discount/${discountCode}`));
				iframe.setAttribute('style', 'display: none;');
				iframe.setAttribute('id', 'discount-iframe');
				iframe.setAttribute('name', 'discount-iframe');
				document.body.appendChild(iframe);
			});
			setTimeout(() => {
				window.location.href = encodeURI(`https://choosemuse.com/discount/${discountCode}`);
			}, 1000);
		}

		if (checkIfPurchasePath()) {
			if (subdomain === 'choosemuse') subdomain = 'us';
			redirectCheck(subdomain);
		} else if (currentPage.pathname === '/search' && currentPage.hostname !== 'choosemuse.com') {
			redirectTo('search', 'us');
		}
	};

	const redirectCheck = (subdomain) => {
		const cookie = getCookie('_muse_store');
		/* console.log('redirectCheck', subdomain, cookie); */
		if(subdomain != cookie){
			// check if on a PLP, PDP, Cart and the Checkout 
			const productPage = window.location.pathname.includes('/products');
			const ccPage = onPageCheckCart();
			const pathname = currentPage.pathname;
	
			if (ccPage == 'cart') {
				redirectTo('cart', cookie);
			} else if (ccPage == 'checkout') {
				redirectTo('checkout', cookie);
			} else if(productPage) {
				redirectTo('products', cookie);
			} else if (purchasePathPages.find(val => val == pathname)) {
				redirectTo('page-with-pricing', cookie);
			}
		}
	};

	const redirectTo = (page, store) => {
		/* console.log('redirectTo', page, store); */
		const sub = store === 'us' ? 'shop' : store;
		let pageRedirect;

		if(page == 'cart') {
			pageRedirect = '/cart'
		} else if(page == 'checkout') {
			pageRedirect = '/checkout'
		} else if(page == 'search') {
			pageRedirect = `/search${window.location.search}`
		} else {
			pageRedirect = currentPage.pathname;
		}
		
		if(domains.includes(sub) && location.hostname !== `https://${sub}.choosemuse.com${pageRedirect}`){
			window.location.href = `https://${sub}.choosemuse.com${pageRedirect}`;
		} else if (sub === 'shop' && location.hostname !== 'choosemuse.com') {
			window.location.href = `https://choosemuse.com${pageRedirect}`;
		}

	}
	
	const onPageCheckCart = () => {
		let checkPage;
		if(window.location.pathname == '/cart'){
			checkPage = 'cart';
		} else if(window.location.pathname.includes('/checkouts/')){
			checkPage = 'checkout';
		}
		return checkPage;
	}

	const getCookieForced = () => {
		const discountQueryString = window.location.search;
		const urlParams = new URLSearchParams(discountQueryString);
		const force = urlParams.get('force')
		return force;
	};

	const checkIfPurchasePath = () => {
		return purchasePathPages.map(val => window.location.pathname.includes(val))
					.reduce((prev, cur) => prev ? prev : cur);
	};

	const getSubDomain = () => {
		return window.location.host.split('.')[0];
	};

	const setCookieData = (data, saveLocStorage) => {
		let prev;
		const storeImgs = document.querySelectorAll("img.header__store-flag");
		const storeNames = document.querySelectorAll("span.header__store-content");
		const domain = location.hostname === "localhost" || location.hostname === "127.0.0.1" ? location.hostname : ".choosemuse.com;";
		const match = domains.map(val => {
			const r = storeImgs[0].src.match(`assets/${val}`);
			if (r) prev = val;
			return r;
		}).reduce((prev, cur) => prev ? prev : cur);
		let date = new Date(Date.now() + 86400e3);
		date = date.toUTCString();
		// set cookie and store
		document.cookie = `_muse_store=${data}; expires=${date}; path=/; secure; domain=${domain}`;
		if (prev) document.cookie = `_muse_store_prev=${prev}; expires=${date}; path=/; secure; domain=${domain}`;
		if (saveLocStorage) localStorage.setItem('muse_location', data);
		storeImgs.forEach(el => el.src = el.src.replace(match[0], `/assets/${data}`));
		storeNames.forEach(el => el.textContent = data === 'eu' ? 'EU / UK Store' : `${data.toUpperCase()} Store`);
	};

	const setCookieDataFromMenu = () => {
		const regionLink = document.querySelectorAll(".theme-redirect-modal__tab-country button");
		
		regionLink.forEach((element) => {
			element.addEventListener("click", function (event) {
				const locationData = element.dataset.locationLink;
				setCookieData(locationData, true);
				if (checkIfPurchasePath()) {
					window.location.reload();
				} 
				closeModule();
			});
		});
	};

	const closeModule = () => {
		document.querySelector(".theme-redirect-modal").classList.remove(
			"theme-redirect-modal--active"
		);
		document.querySelector('body').classList.remove('modal--active');
		document.querySelector('html').classList.remove('modal--active');
		document.querySelector('.theme-redirect-modal__overlay').classList.remove('theme-redirect-modal__overlay--active');
		 
	}

	const getCookie = (name) => {
		let matches = document.cookie.match(new RegExp(
		  "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
		));
		return matches ? matches[1] : false;
	}

	return init();
}
